import { render, staticRenderFns } from "./UMLClassDefinition.vue?vue&type=template&id=3af97350&scoped=true&"
import script from "./UMLClassDefinition.vue?vue&type=script&lang=js&"
export * from "./UMLClassDefinition.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3af97350",
  null
  
)

export default component.exports